import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(
    private toastr: ToastrService
  ) { }

  showSucesso(mensagem: string){
    this.toastr.success(mensagem);
  }

  showErro(mensagem: string){
    this.toastr.error(mensagem);
  }

  showInformativo(mensagem: string){
    this.toastr.info(mensagem, 'Aviso');
  }
}
